import { UAParser } from "my-ua-parser"

type BrowserInfo = {
	name: string
	version: string | null
}

function getBrowserInfo(): BrowserInfo {
	if (typeof navigator === "undefined" && typeof window === "undefined") {
		return {
			name: "",
			version: null,
		}
	}

	const parsedBrowser = UAParser().browser

	return {
		name: parsedBrowser.name ?? "",
		version: parsedBrowser.version ?? null,
	}
}

const browserInfo = getBrowserInfo()

export const currentBrowserName = browserInfo.name
export const currentBrowserVersion = browserInfo.version
export const isFirefox = currentBrowserName.toLowerCase() === "firefox"
export const isSafari = currentBrowserName.toLowerCase() === "safari"
